export default __webpack_public_path__ + "images/a5274c09efd720b05a44cace3ad091ff-michelle-javier.webp";